@if (translationsReady$()) {
  @if (activeQuestion(); as question) {
    <empathy-question-preview [activeQuestion]="question"></empathy-question-preview>
  } @else if (welcomeScreenActive()) {
    <empathy-welcome-page-preview [editorForm]="editorForm()"></empathy-welcome-page-preview>
  } @else if (endPageScreenActive()) {
    <empathy-end-page-preview [editorForm]="editorForm()"></empathy-end-page-preview>
  }
}
